module.exports = __webpack_public_path__ + "static/media/hand-bell.3ccebbbc.mp3";